<script setup lang="ts">
    import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import { BIReport } from '@/types';
    import QueryKey from '@/enums/QueryKey';
    import { usePage } from '@inertiajs/vue3';
    import type { SharedData } from '@/types';
    import { computed } from 'vue';
    import { usePermissions } from '@/composables/usePermissions';
    import Delete from '@/components/Delete.vue';
    import Permission from '@/enums/Permission';
    import EditBIReport from './EditBIReport.vue';

    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    interface Props {
        biReport: BIReport;
    }

    defineProps<Props>();

    const { hasPermission } = usePermissions();
</script>

<template>
    <DataTableActions :data="biReport">
        <EditBIReport
            v-if="hasPermission(Permission.POWERBI_SETUP_UPDATE)"
            :bi-report="biReport"
        />
        <Delete
            v-if="hasPermission(Permission.POWERBI_SETUP_DELETE)"
            :route="route('v2.powerbi.setup.destroy', biReport.id)"
            :query-key="[QueryKey.POWER_BI, selectedCompanyId]"
            header="bi_and_companies.delete_bi_row"
            description="bi_and_companies.delete_bi_row_content"
        />
    </DataTableActions>
</template>
